function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M970.977 360.505H1042.16C1010.41 309.904 986.816 259.404 969.797 216.404C928.577 112.325 915.837 28.1247 915.577 26.4045C915.02 22.4267 913.682 18.5979 911.64 15.1384C909.599 11.6789 906.894 8.65669 903.682 6.24556C900.469 3.83418 896.812 2.08125 892.919 1.08711C889.027 0.0932127 884.978 -0.122119 881.002 0.45332C877.026 1.02876 873.204 2.38398 869.754 4.44087C866.304 6.498 863.294 9.21602 860.896 12.4396C858.5 15.663 856.764 19.3281 855.787 23.2246C854.811 27.1208 854.613 31.1718 855.207 35.1445C855.736 38.8146 868.736 126.355 912.477 237.365C929.074 279.728 948.623 320.876 970.977 360.505ZM2405.45 1757.37C2431.38 1717.98 2450.51 1677.76 2462.31 1637.76C2492.38 1535.87 2483.89 1435.94 2437.08 1340.73C2396.59 1258.37 2328.75 1179.9 2229.69 1100.9C2051.79 958.97 1805.9 842.93 1588.9 740.55L1588.63 740.421C1431.7 666.369 1283.47 596.423 1196.52 531.93C1131.12 483.45 1080.54 421.93 1041.97 360.54H970.75C981.497 379.48 992.75 397.673 1004.51 415.12C1049.5 481.93 1101.87 537.7 1160.19 580.93C1252.07 649.05 1396.1 717.02 1562.87 795.71C1776.82 896.67 2019.31 1011.1 2191.65 1148.58C2383.06 1301.27 2452.46 1455.64 2403.8 1620.49C2384.53 1685.76 2343.61 1748.43 2286.03 1809H2367.28L2286.13 1809.04C2086.44 2019.21 1686.6 2204.02 1296.97 2384.1L1296.61 2384.27L1296.2 2384.46C1065.49 2491.1 828.059 2600.85 636.022 2715.08C604.516 2733.77 574.383 2752.59 545.623 2771.53C502.89 2799.67 464.3 2827.41 429.853 2854.74C285.353 2960 100.772 3110.73 0.472656 3257V3258H0.25V5047H2639.25V4799.48C2627.72 4787.38 2614.95 4775.18 2600.93 4762.88C2546.45 4715.12 2472.63 4665.26 2375.25 4610.44C2195.35 4509.22 1960.04 4405.21 1710.92 4295.1L1710.49 4294.92C1361.49 4140.73 1000.74 3981.3 719.49 3800.7C568.57 3703.78 457.6 3611.74 380.25 3519.32C305.75 3430.34 265.25 3344.51 257.02 3258H257.293C256.246 3249.1 255.722 3240.15 255.723 3231.19C255.723 3162.03 283.742 3094.19 341.393 3023.81C394.982 2958.38 472.772 2892.51 579.213 2822.44C779.979 2690.23 1055.56 2562.85 1322.08 2439.66L1322.21 2439.6L1322.31 2439.55C1576.31 2322.16 1838.94 2200.77 2046.06 2071.86C2158.78 2001.7 2246.19 1935.14 2313.27 1868.38C2332.3 1849.51 2350.37 1829.69 2367.39 1809H2367.28C2380.89 1792.46 2393.63 1775.23 2405.45 1757.37Z",
  fill: "url(#wire_paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "wire_paint0_linear",
  x1: 1017.01,
  y1: 0.138689,
  x2: 357.536,
  y2: 3536.37,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0165518,
  stopColor: "#4366C0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.10046,
  stopColor: "#4366C0",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.244792,
  stopColor: "#4366C0",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.837272,
  stopColor: "#4366C0",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.963542,
  stopColor: "#4366C0"
})));

function SvgWire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2640 5047",
    preserveAspectRatio: "none",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWire);
export default __webpack_public_path__ + "static/media/wire.a3409602.svg";
export { ForwardRef as ReactComponent };